import React, { useState, useEffect, useContext } from "react";
import NumberFormat from "react-number-format";
import { makeStyles } from "@material-ui/core/styles";
import { CSVLink } from "react-csv";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import GetAppIcon from "@material-ui/icons/GetApp";
import { generateTimestampId } from "../../../functions";
import { updateCategorias } from "../../../components/CategoriasList";
import { fetchProductos, SinProductos } from "../../../components/ProductosList";
import ImageLoader from "../../../components/ImageLoader";
import ProductoCreate from "../../../components/ProductoCreate";
import ProductoDetails from "../../../components/ProductoDetails";
import { AppContext } from "../../App";

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  container: {
    height: "calc(100vh - 56px)",
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
      height: "calc(100vh - 48px)"
    },
    [theme.breakpoints.up("sm")]: {
      height: "calc(100vh - 64px)"
    }
  },
  paper: {
    minHeight: "100%",
    backgroundColor: "#fafafa"
  },
  secondaryAction: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  loading: {
    minHeight: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fafafa"
  },
  appButton: {
    marginRight: theme.spacing(2),
    color: "white",
    "&:hover": {
      color: "white"
    }
  }
}));

const Categoria = ({ category, selected, disabled, canEdit, onClick, onChange }) => {
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState(null);
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (category) {
      setValue(category.value);
      setLabel(category.label);
    }
  }, [category]);

  const agregar = () => {
    const newLabel = label.trim();

    if (newLabel !== "") {
      onChange({
        value: generateTimestampId(),
        label: label.trim()
      });

      setValue(null);
      setLabel("");
    }
  };

  const guardar = () => {
    if (label !== "") {
      onChange({ value, label: label.trim() });

      setEdit(false);
    }
  };

  const keyDown = event => {
    if (event.keyCode === 13) {
      if (edit) {
        guardar();
      } else {
        agregar();
      }
    }
  };

  if (category) {
    if (edit) {
      return (
        <ListItem selected={selected}>
          <ListItemText
            primary={
              <TextField
                fullWidth
                size="small"
                placeholder="Nombre de categoría"
                disabled={disabled}
                value={label}
                onChange={({ target }) => setLabel(target.value)}
                inputProps={{
                  maxLength: 25
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" disabled={disabled} onClick={guardar}>
                        <SaveIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                onKeyDown={keyDown}
              />
            }
          />
        </ListItem>
      );
    } else {
      return (
        <ListItem button disabled={disabled} selected={selected} onClick={() => onClick(value)}>
          <ListItemText primary={label} />
          {canEdit && (
            <ListItemSecondaryAction>
              <IconButton edge="end" disabled={disabled} onClick={() => setEdit(true)}>
                <EditIcon />
              </IconButton>
            </ListItemSecondaryAction>
          )}
        </ListItem>
      );
    }
  } else {
    return (
      <ListItem selected={selected}>
        <ListItemText
          primary={
            <TextField
              fullWidth
              size="small"
              placeholder="Agregar categoría"
              disabled={disabled}
              value={label}
              onChange={({ target }) => setLabel(target.value)}
              inputProps={{
                maxLength: 25
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" disabled={disabled} onClick={agregar}>
                      <AddIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              onKeyDown={keyDown}
            />
          }
        />
      </ListItem>
    );
  }
};

const Catalogo = () => {
  const classes = useStyles();
  const { store, productosCount, onProductosCountChange, onStoreChange } = useContext(AppContext);
  const [fetchingProductos, setFechingProductos] = useState(true);
  const [sendingCategorias, setSendingCategorias] = useState(false);
  const [productos, setProductos] = useState([]);
  const [producto, setProducto] = useState(null);
  const [filtros, setFiltros] = useState([]);
  const [filtro, setFiltro] = useState(0);
  const [lista, setLista] = useState([...productos]);
  const [openCreate, setOpenCreate] = useState(false);

  useEffect(() => {
    if (store.id) {
      fetchProductos(
        store.id,
        () => {
          setFechingProductos(true);
          setProducto(null);
        },
        () => {
          setFechingProductos(false);
        },
        productos => {
          onProductosCountChange(productos.length);
          setProductos(productos);
        }
      );
    }
  }, [store.id, onProductosCountChange]);

  useEffect(() => {
    const todos = {
      value: null,
      label: `Todos los productos`,
      items: productos
    };

    const list = [todos];

    const inactivos = {
      value: 0,
      label: "Inactivos",
      items: productos.filter(p => p.status === 0) || []
    };

    list.push(inactivos);

    if (store.body.categories.length > 1) {
      for (let i = 0; i < store.body.categories.length; i++) {
        const item = store.body.categories[i];
        item.items =
          productos.filter(p => p.body.category === item.value && Boolean(p.status)) || [];

        list.push(item);
      }
    }

    setFiltros(list);
  }, [store.body.categories, productos]);

  useEffect(() => {
    if (filtro) {
      if (filtro === -1) {
        setLista([]);
      } else {
        setLista(filtros[filtro].items || []);
      }
    } else {
      setLista(productos);
    }
  }, [filtros, filtro, productos]);

  const refresh = () => {
    fetchProductos(
      store.id,
      () => {
        setFechingProductos(true);
        setProducto(null);
      },
      () => {
        setFechingProductos(false);
      },
      productos => {
        onProductosCountChange(productos.length);
        setProductos(productos);
      }
    );
  };

  const updateCategoria = updatedCategoria => {
    updateCategorias(
      "update",
      updatedCategoria,
      store,
      () => {
        setSendingCategorias(true);
      },
      () => {
        setSendingCategorias(false);
      },
      onStoreChange
    );
  };

  const newCategoria = newCategoria => {
    updateCategorias(
      "create",
      newCategoria,
      store,
      () => {
        setSendingCategorias(true);
      },
      () => {
        setSendingCategorias(false);
      },
      onStoreChange
    );
  };

  const exportCsv = () => {
    const headers = [
      { label: "ID", key: "id" },
      { label: "Título", key: "titulo" },
      { label: "Descripción", key: "descripcion" },
      { label: "Enlace", key: "enlace" },
      { label: "Estado", key: "estado" },
      { label: "Precio", key: "precio" },
      { label: "Disponibilidad", key: "disponibilidad" },
      { label: "Enlace_imágen", key: "imagen" },
      { label: "GTIN", key: "gtin" },
      { label: "MPN", key: "mpn" },
      { label: "Marca", key: "marca" },
      { label: "Categoría", key: "categoria" }
    ];

    const data = [];
    const env = process.env.REACT_APP_ENV === "dev" ? "dev" : "";

    productos.map(producto => {
      let description;

      if (producto.body.description) {
        description = producto.body.description.replace(/\n/g, " ");
        description = description.replace(/\r/g, " ");
      }

      return data.push({
        id: producto.id,
        titulo: producto.name,
        descripcion: description,
        enlace: `https://${env}ads.carritofacil.cl/${store.slug}/${producto.slug}`,
        estado: "",
        precio: producto.price,
        disponibilidad: "",
        imagen: producto.medias[0]
          ? `https://${env}media.carritofacil.cl/?key=${producto.medias[0].key}`
          : "",
        gtin: "",
        mpn: "",
        marca: "",
        categoria: (store.body.categories.find(c => c.value === producto.body.category) || {}).label
      });
    });

    const csvReport = {
      data: data,
      headers: headers,
      filename: `Reporte_productos-${store.slug}-${new Date().toLocaleDateString("es-CL")}.csv`
    };

    return (
      <CSVLink {...csvReport} className={classes.appButton}>
        <GetAppIcon />
      </CSVLink>
    );
  };

  return (
    <>
      <ProductoCreate open={openCreate} onCreated={refresh} onClose={() => setOpenCreate(false)} />
      <ProductoDetails producto={producto} onChange={refresh} onClose={() => setProducto(null)} />

      <AppBar position="sticky">
        <Toolbar>
          <Typography className={classes.title} variant="h6">
            Catálogo
          </Typography>

          {exportCsv()}

          <IconButton edge="end" color="inherit" onClick={() => setOpenCreate(true)}>
            <AddIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {productosCount === 0 ? (
        <SinProductos onClick={() => setOpenCreate(true)} />
      ) : (
        <Grid container className={classes.container}>
          <Grid item xs={4}>
            <Paper square className={classes.paper}>
              <List disablePadding>
                {filtros.map((f, i) => (
                  <Categoria
                    key={`filtro-${i}`}
                    canEdit={i > 1}
                    category={f}
                    selected={i === filtro}
                    disabled={sendingCategorias}
                    onClick={() => setFiltro(i)}
                    onChange={updateCategoria}
                  />
                ))}

                <Categoria disabled={sendingCategorias} onChange={newCategoria} />
              </List>
            </Paper>
          </Grid>

          <Grid item xs={8}>
            {fetchingProductos ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              <Paper square className={classes.paper}>
                <List disablePadding>
                  {lista.map((producto, index) => (
                    <ListItem
                      key={`item-${index}`}
                      button
                      divider
                      dense
                      alignItems="flex-start"
                      onClick={() => setProducto(producto)}
                    >
                      {producto.medias.length > 0 && (
                        <ListItemAvatar>
                          <ImageLoader
                            avatar
                            thumb
                            variant="rounded"
                            imgKey={producto.medias[0].key}
                            alt={producto.name}
                          />
                        </ListItemAvatar>
                      )}
                      <ListItemText
                        primary={producto.name}
                        secondary={
                          (
                            store.body.categories.find(c => c.value === producto.body.category) ||
                            {}
                          ).label
                        }
                      />
                      <ListItemSecondaryAction onClick={() => setProducto(producto)}>
                        <div className={classes.secondaryAction}>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            align="right"
                            className="mr-3"
                          >
                            <NumberFormat
                              value={producto.price}
                              thousandSeparator="."
                              decimalSeparator=","
                              prefix="$"
                              displayType={"text"}
                            />
                            <br />
                            {Boolean(producto.status) ? "Activo" : "Inactivo"}
                          </Typography>

                          <ChevronRightIcon color="primary" />
                        </div>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Catalogo;
